/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc */
	/*jshint smarttabs:true */

	/**
	 * PexDocumentList module implementation.
	 *
	 * @author Walid Ghazzo
	 * @namespace Tc.Module
	 * @class PexDocumentList
	 * @extends Tc.Module
	 */
	Tc.Module.PexDocumentList = Tc.Module.extend({

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.initModel();
			callback();
		},

		/**
		 * Initializes the model
		 * @method initModel
		 * @return {Tc.Module.PexDocumentList} Module
		 */
		initModel: function () {
			var mod = this,
				$ctx = mod.$ctx,
				url = $ctx.data("action");

			var data = $.getJSON(url, function (response) {
				$ctx.find('.scs-loadingRotator').addClass('hidden');
				
				// Success: fetch json and apply bindings
				var templateScript = mod.$ctx.find('script.tmpl-pexdocumentlistview'),
					template = doT.template(templateScript.html());

				templateScript.after(template(response));
				
			}).fail(function() {
				
				// Fail: hide table and show error
				$ctx.find('.scs-loadingRotator').addClass('hidden');
				$ctx.find('table').hide();
				$ctx.find('.error').removeClass('hidden').show();
			});

			return mod;
		}
	});
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexDocumentList.js
// module id = 162
// module chunks = 0